<template>
    <div class="pc-tradedetail inner-box">
        <bread backTitle="全部数据" backRouter="/tradelist" secTitle="数据详情"></bread>

        <h1>数据详情</h1>
        <div class="not-found table-shadow" v-if="txNotFound">
            <p>
                未查询到数据信息，
                <span @click="
                    txNotFound = false;
                getTradeDetail(hash);
                ">重试</span>
            </p>
        </div>
        <!-- 表格部分 -->
        <div class="data-table table-shadow" v-else>
            <div class="head">
                <span>概况</span>
            </div>
            <div class="item line flex-left">
                <label>
                    <span>数据哈希</span>
                </label>
                <div class="item-text">
                    <span>{{ hash }}</span>
                    <i class="iconfont iconfuzhi1 copy-txt" v-clipboard:copy="hash" v-clipboard:success="success"
                        v-clipboard:error="error"></i>
                </div>
            </div>
            <div class="item flex-left">
                <label>
                    <span>接收状态</span>
                </label>
                <div class="item-text">
                    <span :class="['status', trade.state ? 'success' : 'faild']">
                        <i class="iconfont" :class="trade.state ? 'iconchenggong' : 'iconcuowu'"></i>
                        {{ trade.state ? "成功" : "失败" }}
                    </span>
                </div>
            </div>
            <div class="item line flex-left">
                <label>
                    <span>区块高度</span>
                </label>
                <div class="item-text">
                    <router-link :to="`/blockDetail?height=${trade.detail.height}`" class="light">{{ trade.detail.height
                    }}</router-link>
                </div>
            </div>
            <div class="item flex-left">
                <label>
                    <span>时间 (UTC+8)</span>
                </label>
                <div class="item-text">
                    {{ caculateTime(trade.detail.blockTime) }}
                </div>
            </div>
            <div class="item line flex-left">
                <label>
                    <span>发送方</span>
                </label>
                <div class="item-text">
                    <router-link :to="`/address?address=${trade.detail.fromAddr}`" class="light">{{
                        trade.detail.fromAddr }}</router-link>
                </div>
            </div>
            <div class="item flex-left">
                <label>
                    <span>接收方</span>
                </label>
                <div class="item-text">
                    <router-link :to="`/address?address=${trade.detail.tx.to}`" class="light">{{ trade.detail.tx.to
                    }}</router-link>
                </div>
            </div>
            <div class="item line flex-left" v-if="erc20Tokens.Events">
                <label>
                    <span>ERC-20 Tokens</span>
                </label>
                <div class="item-text">
                    <!-- erc20转账记录 -->
                    <div class="erc20-tokens" v-for="item in erc20Tokens.Events" :key="item.EventIndex">
                        ><span>From
                            <router-link :to="`/address?address=${item.Args.from}`" class="light">
                                {{ filterHash(item.Args.from) }}
                            </router-link>
                        </span>
                        <span> To
                            <router-link :to="`/address?address=${item.Args.to}`" class="light">
                                {{ filterHash(item.Args.to) }}
                            </router-link>
                        </span>
                        <span> For {{ item.Args.value / 10 ** item.Args.token_decimals }} {{
                            item.Args.token_symbol }}</span>
                    </div>
                </div>
            </div>
            <div class="item line flex-left">
                <label>
                    <span>随机数</span>
                </label>
                <div class="item-text">{{ String(trade.detail.tx.nonce) }}</div>
            </div>
            <div class="item flex-left">
                <label>
                    <span>执行器</span>
                </label>
                <div class="item-text">{{ trade.detail.tx.execer }}</div>
            </div>
            <div class="item line flex-left">
                <label>
                    <span>数据类型</span>
                </label>
                <div class="item-text">{{ tradeGroup(trade) }}</div>
            </div>
            <div class="markdown-data" v-if="trade.detail.tx.execer === 'user.write'">
                <Markdown :content="trade.markdownTxt"></Markdown>
            </div>
            <div class="area" v-if="trade.detail.tx.execer !== 'user.write'">
                <label>
                    <span>输入数据</span>
                </label>
                <div class="item-text">
                    <pre class="preTxt" contenteditable="true">
          <code>{{ decodeTransferNote(trade.detail.tx) }}</code>
          </pre>
                </div>
            </div>
            <div class="area" v-if="trade.detail.tx.execer !== 'user.write'">
                <label>
                    <span>输出数据</span>
                </label>
                <div class="item-text">
                    <pre class="preTxt" contenteditable="true">
          <code>{{ trade.detail.receipt }}</code>
          </pre>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Bread from "@/components/computer/Breadcrumb.vue";
import Markdown from "@/components/common/markdown.vue";
import { decodeTransferNote, tradeGroup, caculateTime, filterHash } from "@/utils/filters";
import TradeMixins from "@/mixins/trade";
import { success, error } from "@/mixins/common";
import { useRoute } from "vue-router";
import { computed, watch } from "vue";

const { txNotFound, trade, erc20Tokens, getTradeDetail } = TradeMixins();
const route = useRoute();
const hash = computed(() => route.query.hash);

watch(
    hash,
    (val) => {
        getTradeDetail(val);
    },
    {
        immediate: true,
    }
);
</script>

<style lang="scss" scoped>
.pc-tradedetail {
    .erc20-tokens {
        font-weight: 600;
        margin: 5px 0;
    }

    h1 {
        margin: 36px 0 16px;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: 500;
        color: $black_title;
    }

    .not-found {
        width: 100%;
        background: $white;
        text-align: center;
        color: $black;

        p {
            font-size: 14px;
            line-height: 52px;
            margin: 15px 0;
        }

        span {
            color: #366c96;
            cursor: pointer;
        }
    }

    .data-table {
        width: 100%;
        color: $black;
        font-size: 14px;
        background: $white;
        border-radius: 2px;
        border: 1px solid rgba(235, 239, 241, 1);

        .head {
            height: 70px;
            border-bottom: 1px solid #eee;

            span {
                display: inline-block;
                height: 100%;
                width: 40px;
                margin-left: 32px;
                line-height: 67px;
                color: $black;
                font-size: 16px;
                font-family: PingFangSC-Semibold;
                font-weight: 500;
                text-align: center;
                border-bottom: 3px solid $blue;
            }
        }

        .item {
            height: 60px;

            label {
                width: 233px;
                display: flex;
                justify-items: left;
                align-items: center;
                padding-left: 32px;
                font-family: PingFangSC-Regular;
            }

            .item-text {
                .status {
                    display: inline-block;
                    padding: 3px 10px;
                    border-radius: 3px;
                    font-size: 14px;

                    i {
                        font-size: 14px;
                    }
                }

                .success {
                    background: rgba(0, 201, 167, 0.1);
                    color: #00c9a7;
                }

                .faild {
                    background: rgba(193, 56, 56, 0.1);
                    color: #c13838;
                }
            }
        }

        .area {
            height: 253px;
            display: flex;
            justify-items: left;
            align-items: flex-start;
            padding-top: 26px;

            label {
                width: 233px;
                display: flex;
                justify-items: left;
                align-items: center;
                padding-left: 32px;

                i {
                    font-size: 20px;
                    color: #b5d2e9;
                }

                span {
                    font-family: PingFangSC-Regular;
                }
            }

            .item-text {
                width: 890px;
                border: 1px solid rgba(235, 239, 241, 1);
                background: $white;
            }

            .preTxt {
                height: 200px;
                padding: 15px;
                font-family: Verdana;
                overflow-y: auto;
                vertical-align: middle;
                width: 100%;
                word-break: break-all;
            }

            code {
                line-height: 1.38;
                margin-left: -49px;
                font-family: "Verdana";
            }

            .preTxt {
                border: 1px solid #ebeff1;
                cursor: default;
                overflow-y: scroll;
                // IE下隐藏
                -ms-overflow-style: none;
                // 火狐浏览器隐藏
                scrollbar-color: transparent transparent;
            }

            .preTxt::-webkit-scrollbar {
                width: 5px;
                height: 5px;
                background: #e0e3e6;
            }

            .preTxt::-webkit-scrollbar-thumb {
                border-radius: 50px;
                background: $blue;
            }
        }

        .markdown-data {
            border-top: 1px solid #eee;
            padding: 40px;
            font-size: 14px;
        }

        .line {
            background: #f9fafc;
        }
    }
}
</style>
